import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { ConfigurableInputsModule } from "../configurable/inputs/configurable-inputs.module";
import { AbbeyToolComponent } from "./abbey-tool/abbey-tool";
import { ComaToseToolComponent } from "./comatose-tool/comatose-tool";
import { FastToolComponent } from "./fast-tool/fast-tool";
import { FlaccToolComponent } from "./flacc-tool/flacc-tool";
import { KarnofskyToolComponent } from "./karnofsky-tool/karnofsky-tool";
import { MmseToolComponent } from "./mmse-tool/mmse-tool";
import { NumericToolComponent } from "./numeric-tool/numeric-tool";
import { NyhaToolComponent } from "./nyha-tool/nyha-tool";
import { PainScreeningToolComponent } from "./pain-screening-tool/pain-screening-tool";
import { PainadToolComponent } from "./painad-tool/painad-tool";
import { PpsToolComponent } from "./pps-tool/pps-tool";
import { ToolCardComponent } from "./tool-card/tool-card";
import { ToolSelectorComponent } from "./tool-selector/tool-selector";
import { VerbalToolComponent } from "./verbal-tool/verbal-tool";
import { WongBakerToolComponent } from "./wong-baker-tool/wong-baker-tool";

@NgModule({
  declarations: [
    AbbeyToolComponent,
    FastToolComponent,
    FlaccToolComponent,
    KarnofskyToolComponent,
    MmseToolComponent,
    NumericToolComponent,
    VerbalToolComponent,
    NyhaToolComponent,
    PainadToolComponent,
    PpsToolComponent,
    ToolCardComponent,
    ToolSelectorComponent,
    WongBakerToolComponent,
    ComaToseToolComponent,
    PainScreeningToolComponent,
  ],
  imports: [ConfigurableInputsModule, IonicModule, TranslateModule.forChild()],
  exports: [
    AbbeyToolComponent,
    FastToolComponent,
    FlaccToolComponent,
    KarnofskyToolComponent,
    MmseToolComponent,
    NumericToolComponent,
    VerbalToolComponent,
    NyhaToolComponent,
    PainadToolComponent,
    PpsToolComponent,
    ToolCardComponent,
    ToolSelectorComponent,
    WongBakerToolComponent,
    ComaToseToolComponent,
    PainScreeningToolComponent,
  ],
})
export class ToolsModule {}



// WEBPACK FOOTER //
// ./src/components/tools/tools.module.ts